import { useEffect } from "react";

import logError from "@utils/logError";
import cn from "@utils/helpers/cn";
import { WebsiteContextProvider } from "@contexts/WebsiteContext";
import Card from "@elements/Card";
import MotionDiv from "@components/elements/MotionDiv";

import Page from "@components/page/Page";

const classNames = cn(`
  col-span-12
  col-start-1
  md:col-span-10
  md:col-start-2
  lg:col-span-6
  lg:col-start-4
`);

const CONFIG = {
  title: "Error",
  displayPageHeader: true,
};

export default function ErrorPage(props) {
  const {
    error,
    _resetErrorBoundary,
  } = props;

  useEffect(() => {
    if (error) {
      console.error(error.message);
      logError(error);
    }
  }, [error]);

  /**************************************************************************************************/

  return (
    <WebsiteContextProvider>
      <Page
        className={classNames}
        config={CONFIG}
      >
        <MotionDiv key="error" type="card">
          <Card
            className="text-center"
            content="Something went wrong!"
          />
        </MotionDiv>
      </Page>
    </WebsiteContextProvider>
  );
}
